import Util from "@/lib/util";
import _ from "lodash";
export default [
  {
    title: Util.L("ActionName"),
    width: 150,
    key: "refTypeCode",
    render: (h: any, params: any) => {
      return h("span", Util.L("RefTypeCode" + params.row.refTypeCode));
    },
  },
  {
    title: Util.L("Code"),
    width: 150,
    key: "objectCode",
  },
  {
    title: Util.L("ExternalCode"),
    width: 150,
    key: "objectExternalCode",
  },
  {
    title: Util.L("ContainerNum"),
    width: 150,
    key: "containerNumber",
  },
  {
    title: Util.L("InvoiceDate"),
    width: 150,
    key: "objectDate",
    render: (h: any, params: any) => {
      if (_.isNil(params.row.objectDate)) return "";
      return h("span", Util.toViewDatePickerString(params.row.objectDate));
    },
  },
  {
    title: Util.L("InvoiceNumber"),
    width: 150,
    key: "invoiceNumber",
  },
  {
    title: Util.L("Status"),
    width: 150,
    key: "statusName",
  },
  {
    title: Util.L("PoReceiptCode"),
    width: 150,
    key: "objectReceiptCode",
  },
  {
    title: Util.L("PoDate"),
    width: 150,
    key: "objectDate",
    render: (h: any, params: any) => {
      return h("span", Util.toViewDateString(params.row.objectDate));
    },
  },
  {
    title: Util.L("SKU"),
    width: 150,
    key: "sku",
  },
  {
    title: Util.L("ProductName"),
    width: 150,
    key: "productName",
  },
  {
    title: Util.L("AssetType"),
    width: 150,
    key: "assetTypeName",
  },
  {
    title: Util.L("ConditionType"),
    width: 150,
    key: "conditionTypeName",
  },
  {
    title: Util.L("ManufactureMonth"),
    width: 150,
    key: "manufactureMonth",
    render: (h: any, params: any) => {
      if (_.isNil(params.row.manufactureMonth)) return "";
      return h("span", Util.toMonthYearString(params.row.manufactureMonth));
    },
  },
  {
    title: Util.L("OrderQty"),
    width: 100,
    key: "orderQty",
    align: "right",
    render: (h: any, params: any) => {
      return h("span", Util.toViewNumberString(params.row.orderQty));
    },
  },
  {
    title: Util.L("ReceivedQty"),
    width: 100,
    key: "receivedQty",
    align: "right",
    render: (h: any, params: any) => {
      return h("span", Util.toViewNumberString(params.row.receivedQty));
    },
  },
  {
    title: Util.L("Receiver"),
    width: 150,
    key: "receiptCreatorName",
  },
  {
    title: Util.L("InboundDate"),
    width: 150,
    key: "receiptCreationTime",
    render: (h: any, params: any) => {
      if (_.isNil(params.row.receiptCreationTime)) return "";
      return h("span", Util.toViewDateString(params.row.receiptCreationTime));
    },
  },
];
